import { render } from "./CreateNotify.vue?vue&type=template&id=297f4d9c"
import script from "./CreateNotify.vue?vue&type=script&lang=js"
export * from "./CreateNotify.vue?vue&type=script&lang=js"

import "./CreateNotify.vue?vue&type=style&index=0&id=297f4d9c&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__